import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../../components/ui/accordion';

const FAQ_ITEMS = [
  {
    value: 'tracking',
    question: 'How do you track where my donation goes?',
    answer: 'Every dollar is accounted for. We maintain detailed financial records of all incoming donations and outgoing expenditures. Our public impact dashboard shows real-time statistics on families served, buckets distributed, and total funds raised. We publish regular community updates with transparent reporting on how funds are allocated across food assistance, hygiene supplies, and emergency aid.',
  },
  {
    value: 'tax',
    question: 'Is my donation tax-deductible?',
    answer: 'Yes. Novena Humanitarian Foundation, Inc. is an IRS-recognized 501(c)(3) public charity (EIN 41-4097072, effective February 2, 2026). Contributions are tax-deductible to the extent permitted by law. After your donation is completed, you can download a PDF receipt directly from the confirmation page. Please retain this receipt for your records.',
  },
  {
    value: 'usage',
    question: 'What does my donation pay for?',
    answer: 'Approximately 60% goes to food and essential supplies, 30% to hygiene products, and 10% to distribution and logistics. Each Community Care Bucket ($25) provides a family with rice, beans, oatmeal, and other staples. For international programs, donations fund the full 3-Pillar Family Support System: food, hygiene, and clean water access.',
  },
  {
    value: 'recurring',
    question: 'How do recurring donations work?',
    answer: 'When you select a recurring donation, your chosen amount is automatically charged each month (or year, if you prefer). This provides consistent, reliable support that helps us plan ahead and serve more families. You can cancel or modify your recurring donation at any time by contacting us directly.',
  },
  {
    value: 'privacy',
    question: 'How do you protect donor privacy?',
    answer: "We take privacy seriously \u2014 for both donors and the families we serve. Your personal information is never shared or sold. When donating, you choose how you appear on our public donor wall: full name and amount, name only, or fully anonymous. We never publish unconsented photos or identifying details of the individuals and families receiving support.",
  },
  {
    value: 'international',
    question: 'Can I donate to a specific country or program?',
    answer: 'Yes. We are building active programs in multiple countries including Haiti, Dominican Republic, Colombia, El Salvador, Ecuador, and Jamaica. You can visit our Global Programs page to donate directly to a specific country\'s program. Donations made to a specific program are allocated entirely to that program.',
  },
];

export const DonateFAQ = () => (
  <section className="py-10 bg-white border-t border-[#E5E7EB]" data-testid="faq-section">
    <div className="px-6">
      <div className="max-w-lg mx-auto">
        <div className="text-center mb-6">
          <div className="w-10 h-10 bg-[#FEE2E2] rounded-full flex items-center justify-center mx-auto mb-3">
            <HelpCircle className="w-5 h-5 text-[#BA1826]" />
          </div>
          <h3 className="font-heading text-xl font-bold text-[#0A0A0A] mb-1">
            Frequently Asked Questions
          </h3>
          <p className="text-xs text-[#4B5563]">
            Transparency is one of our core values. Here are answers to common questions.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQ_ITEMS.map((item) => (
            <AccordionItem key={item.value} value={item.value} data-testid={`faq-item-${item.value}`}>
              <AccordionTrigger className="text-sm font-semibold text-[#0A0A0A] hover:no-underline">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-[#4B5563] leading-relaxed">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
